import { RefreshCw, Wrench } from 'lucide-react';
import { useEffect, useState } from 'react';

import { onMaintenance } from '@/api/client';

/**
 * Pantalla completa mientras la API está en mantenimiento (corte M2). Cualquier respuesta
 * `503 MAINTENANCE` la muestra; "Reintentar" recarga la página.
 */
export function Mantenimiento() {
  const [info, setInfo] = useState<{ until?: string } | null>(null);
  useEffect(() => onMaintenance(setInfo), []);
  if (!info) return null;
  return (
    <div
      role="alertdialog"
      aria-modal="true"
      aria-labelledby="mantenimiento-titulo"
      className="fixed inset-0 z-[100] flex items-center justify-center bg-noche-950/95 p-4"
    >
      <div className="panel-vidrio max-w-md space-y-4 text-center">
        <Wrench className="mx-auto text-cian-texto" size={40} aria-hidden />
        <h1 id="mantenimiento-titulo" className="text-xl font-extrabold">
          Estamos actualizando el panel de Consalud
        </h1>
        <p className="text-texto-2">
          El panel vuelve en unos minutos
          {info.until ? ` (aproximadamente a las ${info.until})` : ''}. Ningún cambio guardado se
          pierde.
        </p>
        <button
          type="button"
          className="btn-cs btn-primario w-full"
          onClick={() => window.location.reload()}
        >
          <RefreshCw size={16} aria-hidden /> Reintentar
        </button>
      </div>
    </div>
  );
}
